@if (initialized) {
  <form [formGroup]="inputForm">
    <div class="container">
      <!-- Result -->
      <section>
        <div class="mat-body-2">Test result:</div>
        @if (!editing) {
          <div class="mat-body">
            @if (smt.status === 'passed') {
              Passed
            }
            @if (smt.status === 'failed') {
              Failed
            }
          </div>
        }
        @if (editing) {
          <mat-radio-group matInput aria-label="Select category" formControlName="result"
            [errorStateMatcher]="matcher">
            <mat-radio-button value="passed">Passed</mat-radio-button>
            <mat-radio-button value="failed">Failed</mat-radio-button>
          </mat-radio-group>
        }
        @if (inputForm.controls.result.hasError('required')) {
          <mat-error>
            This field is <strong>required</strong>
          </mat-error>
        }
        @if (inputForm.controls.result.hasError('error')) {
          <mat-error>
            {{inputForm.controls.type.errors.error}}
          </mat-error>
        }
      </section>
      <!-- /Result -->
      <!-- Comment section -->
      @if (inputForm.controls.result.value == 'failed') {
        <section>
          <div class="mat-body-2">Note:</div>
          @if (!editing) {
            <div class="mat-body">{{smt.failed_reason}}</div>
          }
          @if (editing) {
            <mat-form-field>
              <textarea matInput formControlName="comment" [errorStateMatcher]="matcher"></textarea>
              @if (inputForm.controls.comment.hasError('required')) {
                <mat-error>
                  This field is <strong>required</strong>
                </mat-error>
              }
              @if (inputForm.controls.comment.hasError('error')) {
                <mat-error>
                  {{inputForm.controls.comment.errors.error}}
                </mat-error>
              }
            </mat-form-field>
          }
        </section>
      }
      <!-- /Comment section -->
      <!-- Form Actions -->
      <section>
        @if (editing) {
          <div class="row">
            <button mat-stroked-button color="primary" (click)="saveItem()">Submit</button>
          </div>
        }
      </section>
      <!-- Form Actions -->
    </div>
  </form>
}
